import { ShareableType } from '@bindoc-projects/resource-domain-lib';

export class BdShareablesStore {
  constructor(private readonly _baseUrl: string) {}

  public base(): string {
    return this._baseUrl;
  }

  public archive(shareableType: ShareableType, shareableId: string): string {
    return `${this.base()}/shareables/${shareableType}/${shareableId}/`;
  }

  public checkMyPermissionOn(
    shareableType: ShareableType,
    resourceId: string,
  ): string {
    return `${this.base()}/shareables/${shareableType}/${resourceId}/permissions/current/`;
  }

  public myShareables(): string {
    return `${this.base()}/shareables/`;
  }

  public allLabels(): string {
    return `${this.base()}/shareables/labels/`;
  }

  public restoreShareable(
    shareableType: ShareableType,
    shareableId: string,
  ): string {
    return `${this.base()}/shareables/${shareableType}/${shareableId}/restore/`;
  }

  /**
   * The access graph of a shareable (BDA-5988). Replaces
   * `allowed-permissions-per-share-target`, which the backend removed: it
   * returned only the final permission set per share target and could not see
   * access derived from a containing folder at all.
   */
  public accessGraph(
    shareableType: ShareableType,
    shareableId: string,
  ): string {
    return `${this.base()}/shareables/${shareableType}/${shareableId}/access-graph/`;
  }

  public sharePreview(
    shareableType: ShareableType,
    shareableId: string,
  ): string {
    return `${this.base()}/shareables/${shareableType}/${shareableId}/share-preview/`;
  }

  public rootFolder(): string {
    return `${this.base()}/folders/`;
  }

  public folder(folderId: string): string {
    return `${this.base()}/folders/${folderId}/`;
  }

  public createFolder(): string {
    return `${this.base()}/folders/`;
  }

  public renameFolder(folderId: string): string {
    return `${this.base()}/folders/${folderId}/`;
  }

  public moveShareable(): string {
    return `${this.base()}/folders/move/`;
  }

  public recycleBin(): string {
    return `${this.base()}/folders/recycle-bin/`;
  }

  public groupRootFolder(groupId: string): string {
    return `${this.base()}/folders/groups/${groupId}/`;
  }

  public groupRecycleBin(groupId: string): string {
    return `${this.base()}/folders/groups/${groupId}/recycle-bin/`;
  }

  public myGroups(): string {
    return `${this.base()}/groups/`;
  }

  public group(groupId: string): string {
    return `${this.base()}/groups/${groupId}/`;
  }

  public myCompanies(): string {
    return `${this.base()}/companies/`;
  }

  /**
   * No trailing slash — unlike its siblings. The backend maps exactly
   * `GET /companies/{id}`, and Spring no longer treats `/{id}/` as the same
   * path: with the slash every lookup answered 404, which left the company
   * crumb of a group's breadcrumb without its name.
   */
  public company(companyId: string): string {
    return `${this.base()}/companies/${companyId}`;
  }

  public companyGroups(companyId: string): string {
    return `${this.base()}/companies/${companyId}/groups/`;
  }

  public users(): string {
    return `${this.base()}/users/`;
  }

  public labels(shareableType: ShareableType, shareableId: string): string {
    return `${this.base()}/shareables/${shareableType}/${shareableId}/labels/`;
  }
}
